module.exports = __webpack_public_path__ + "static/media/hourglass_red_fullec067bd47425f9d342b38e2ec3f8dae6.webp";